"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
exports.Adwords = props => {
    return (react_1.default.createElement(core_1.SvgIcon, Object.assign({}, props),
        react_1.default.createElement("path", { fill: "#28B446", d: "M24,23.226375 L17.890125,23.226375 C16.9341563,23.226375 16.0827188,22.6230469 15.7665937,21.721875 L12.4200937,12.1905 L12,10.994625 L12.1259531,5.15554687 L15.8522344,0.023671875 L16.9568438,3.16992187 L24,23.226375 Z" }),
        react_1.default.createElement("polygon", { fill: "#219B38", points: "16.9567969 3.169875 12.4200469 12.1905 12 10.994625 12.1259531 5.1555 15.8522344 0.023625" }),
        react_1.default.createElement("path", { fill: "#518EF8", d: "M15.8522344,0.023625 L12,10.994625 L8.23279687,21.7212656 C7.91667187,22.6230937 7.06523437,23.226375 6.10926562,23.226375 L0,23.226375 L8.14715625,0.023625 L15.8522344,0.023625 Z" })));
};
//# sourceMappingURL=adwords.js.map